/**
 * 按钮渠道配置
 * 每个按钮可以配置不同渠道号对应的链接，同一渠道号下不同按钮可跳转到不同链接
 */
// 默認報名連結：對應設計稿 fengsuidashi_new_landing.html 全站 CTA 統一入口
const DEFAULT_URL = 'https://diversion.salesmartly.com/split/whatsapp/fkyrju';

export const BUTTON_CHANNEL_CONFIG = {
  topBtn: {
    aosp_jfe5_00001: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
    aosp_jfe5_00002: 'https://diversion.salesmartly.com/split/whatsapp/fj3imw',
    aosp_jfe5_00003: 'https://diversion.salesmartly.com/split/whatsapp/fgjhwk',
    aosp_jfe5_00004: 'https://diversion.salesmartly.com/split/whatsapp/fl1r2l',
    aosp_jfe5_00005: 'https://diversion.salesmartly.com/split/whatsapp/fk4itl',
    aosp_jfe5_00006: 'https://diversion.salesmartly.com/split/whatsapp/flld2p',
    aosp_jfe5_00007: 'https://diversion.salesmartly.com/split/whatsapp/fmea75',
    aosp_jfe5_00008: 'https://diversion.salesmartly.com/split/whatsapp/fmeb7e',
    aosp_jfe5_00009: 'https://diversion.salesmartly.com/split/whatsapp/fmmyes',
    aosp_jfe5_00010: 'https://diversion.salesmartly.com/split/whatsapp/fmn0f2',
    aosp_jfe5_00011: 'https://line.me/R/ti/p/@704dhopl',
  },
  masterBtn: {
    aosp_jfe5_00001: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
    aosp_jfe5_00002: 'https://diversion.salesmartly.com/split/whatsapp/fj3jn6',
    aosp_jfe5_00003: 'https://diversion.salesmartly.com/split/whatsapp/fgjhwk',
    aosp_jfe5_00004: 'https://diversion.salesmartly.com/split/whatsapp/fl1r2l',
    aosp_jfe5_00005: 'https://diversion.salesmartly.com/split/whatsapp/fk4itl',
    aosp_jfe5_00006: 'https://diversion.salesmartly.com/split/whatsapp/flld2p',
    aosp_jfe5_00007: 'https://diversion.salesmartly.com/split/whatsapp/fmea75',
    aosp_jfe5_00008: 'https://diversion.salesmartly.com/split/whatsapp/fmeb7e',
    aosp_jfe5_00009: 'https://diversion.salesmartly.com/split/whatsapp/fmmyes',
    aosp_jfe5_00010: 'https://diversion.salesmartly.com/split/whatsapp/fmn0f2',
    aosp_jfe5_00011: 'https://line.me/R/ti/p/@704dhopl',
  },
  service1Btn: {
    aosp_jfe5_00001: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
    aosp_jfe5_00002: 'https://diversion.salesmartly.com/split/whatsapp/fj3knf',
    aosp_jfe5_00003: 'https://diversion.salesmartly.com/split/whatsapp/fgjhwk',
    aosp_jfe5_00004: 'https://diversion.salesmartly.com/split/whatsapp/fl1r2l',
    aosp_jfe5_00005: 'https://diversion.salesmartly.com/split/whatsapp/fk4itl',
    aosp_jfe5_00006: 'https://diversion.salesmartly.com/split/whatsapp/flld2p',
    aosp_jfe5_00007: 'https://diversion.salesmartly.com/split/whatsapp/fmea75',
    aosp_jfe5_00008: 'https://diversion.salesmartly.com/split/whatsapp/fmeb7e',
    aosp_jfe5_00009: 'https://diversion.salesmartly.com/split/whatsapp/fmmyes',
    aosp_jfe5_00010: 'https://diversion.salesmartly.com/split/whatsapp/fmn0f2',
    aosp_jfe5_00011: 'https://line.me/R/ti/p/@704dhopl',
  },
  service2Btn: {
    aosp_jfe5_00001: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
    aosp_jfe5_00002: 'https://diversion.salesmartly.com/split/whatsapp/fj3lno',
    aosp_jfe5_00003: 'https://diversion.salesmartly.com/split/whatsapp/fgjhwk',
    aosp_jfe5_00004: 'https://diversion.salesmartly.com/split/whatsapp/fl1r2l',
    aosp_jfe5_00005: 'https://diversion.salesmartly.com/split/whatsapp/fk4itl',
    aosp_jfe5_00006: 'https://diversion.salesmartly.com/split/whatsapp/flld2p',
    aosp_jfe5_00007: 'https://diversion.salesmartly.com/split/whatsapp/fmea75',
    aosp_jfe5_00008: 'https://diversion.salesmartly.com/split/whatsapp/fmeb7e',
    aosp_jfe5_00009: 'https://diversion.salesmartly.com/split/whatsapp/fmmyes',
    aosp_jfe5_00010: 'https://diversion.salesmartly.com/split/whatsapp/fmn0f2',
    aosp_jfe5_00011: 'https://line.me/R/ti/p/@704dhopl',
  },
  service3Btn: {
    aosp_jfe5_00001: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
    aosp_jfe5_00002: 'https://diversion.salesmartly.com/split/whatsapp/fj3mnx',
    aosp_jfe5_00003: 'https://diversion.salesmartly.com/split/whatsapp/fgjhwk',
    aosp_jfe5_00004: 'https://diversion.salesmartly.com/split/whatsapp/fl1r2l',
    aosp_jfe5_00005: 'https://diversion.salesmartly.com/split/whatsapp/fk4itl',
    aosp_jfe5_00006: 'https://diversion.salesmartly.com/split/whatsapp/flld2p',
    aosp_jfe5_00007: 'https://diversion.salesmartly.com/split/whatsapp/fmea75',
    aosp_jfe5_00008: 'https://diversion.salesmartly.com/split/whatsapp/fmeb7e',
    aosp_jfe5_00009: 'https://diversion.salesmartly.com/split/whatsapp/fmmyes',
    aosp_jfe5_00010: 'https://diversion.salesmartly.com/split/whatsapp/fmn0f2',
    aosp_jfe5_00011: 'https://line.me/R/ti/p/@704dhopl',
  },
  service4Btn: {
    aosp_jfe5_00001: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
    aosp_jfe5_00002: 'https://diversion.salesmartly.com/split/whatsapp/fj3no7',
    aosp_jfe5_00003: 'https://diversion.salesmartly.com/split/whatsapp/fgjhwk',
    aosp_jfe5_00004: 'https://diversion.salesmartly.com/split/whatsapp/fl1r2l',
    aosp_jfe5_00005: 'https://diversion.salesmartly.com/split/whatsapp/fk4itl',
    aosp_jfe5_00006: 'https://diversion.salesmartly.com/split/whatsapp/flld2p',
    aosp_jfe5_00007: 'https://diversion.salesmartly.com/split/whatsapp/fmea75',
    aosp_jfe5_00008: 'https://diversion.salesmartly.com/split/whatsapp/fmeb7e',
    aosp_jfe5_00009: 'https://diversion.salesmartly.com/split/whatsapp/fmmyes',
    aosp_jfe5_00010: 'https://diversion.salesmartly.com/split/whatsapp/fmn0f2',
    aosp_jfe5_00011: 'https://line.me/R/ti/p/@704dhopl',
  },
  service5Btn: {
    aosp_jfe5_00001: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
    aosp_jfe5_00002: 'https://diversion.salesmartly.com/split/whatsapp/fj3oog',
    aosp_jfe5_00003: 'https://diversion.salesmartly.com/split/whatsapp/fgjhwk',
    aosp_jfe5_00004: 'https://diversion.salesmartly.com/split/whatsapp/fl1r2l',
    aosp_jfe5_00005: 'https://diversion.salesmartly.com/split/whatsapp/fk4itl',
    aosp_jfe5_00006: 'https://diversion.salesmartly.com/split/whatsapp/flld2p',
    aosp_jfe5_00007: 'https://diversion.salesmartly.com/split/whatsapp/fmea75',
    aosp_jfe5_00008: 'https://diversion.salesmartly.com/split/whatsapp/fmeb7e',
    aosp_jfe5_00009: 'https://diversion.salesmartly.com/split/whatsapp/fmmyes',
    aosp_jfe5_00010: 'https://diversion.salesmartly.com/split/whatsapp/fmn0f2',
    aosp_jfe5_00011: 'https://line.me/R/ti/p/@704dhopl',
  },
  service6Btn: {
    aosp_jfe5_00001: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
    aosp_jfe5_00002: 'https://diversion.salesmartly.com/split/whatsapp/fj3pop',
    aosp_jfe5_00003: 'https://diversion.salesmartly.com/split/whatsapp/fgjhwk',
    aosp_jfe5_00004: 'https://diversion.salesmartly.com/split/whatsapp/fl1r2l',
    aosp_jfe5_00005: 'https://diversion.salesmartly.com/split/whatsapp/fk4itl',
    aosp_jfe5_00006: 'https://diversion.salesmartly.com/split/whatsapp/flld2p',
    aosp_jfe5_00007: 'https://diversion.salesmartly.com/split/whatsapp/fmea75',
    aosp_jfe5_00008: 'https://diversion.salesmartly.com/split/whatsapp/fmeb7e',
    aosp_jfe5_00009: 'https://diversion.salesmartly.com/split/whatsapp/fmmyes',
    aosp_jfe5_00010: 'https://diversion.salesmartly.com/split/whatsapp/fmn0f2',
    aosp_jfe5_00011: 'https://line.me/R/ti/p/@704dhopl',
  },
  formSubmit: {
    aosp_jfe5_00001: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
    aosp_jfe5_00002: 'https://diversion.salesmartly.com/split/whatsapp/fj3imw',
    aosp_jfe5_00003: 'https://diversion.salesmartly.com/split/whatsapp/fgjhwk',
    aosp_jfe5_00004: 'https://diversion.salesmartly.com/split/whatsapp/fl1r2l',
    aosp_jfe5_00005: 'https://diversion.salesmartly.com/split/whatsapp/fk4itl',
    aosp_jfe5_00006: 'https://diversion.salesmartly.com/split/whatsapp/flld2p',
    aosp_jfe5_00007: 'https://diversion.salesmartly.com/split/whatsapp/fmea75',
    aosp_jfe5_00008: 'https://diversion.salesmartly.com/split/whatsapp/fmeb7e',
    aosp_jfe5_00009: 'https://diversion.salesmartly.com/split/whatsapp/fmmyes',
    aosp_jfe5_00010: 'https://diversion.salesmartly.com/split/whatsapp/fmn0f2',
    aosp_jfe5_00011: 'https://line.me/R/ti/p/@704dhopl',
  },
};

/**
 * 根据按钮类型和渠道号获取对应的链接
 * @param {string} buttonType - 按钮类型
 * @param {string} channel - 渠道号
 * @returns {string} 链接地址
 */
export function getButtonUrl(buttonType, channel) {
  const buttonConfig = BUTTON_CHANNEL_CONFIG[buttonType];

  if (!buttonConfig) {
    console.warn(`未找到按钮类型 "${buttonType}" 的配置，使用默认链接`);
    return DEFAULT_URL;
  }

  if (!channel) {
    return DEFAULT_URL;
  }

  return buttonConfig[channel] || DEFAULT_URL;
}
